import { useAuth } from "../contexts/AuthContext";
import type { UnitSystem } from "../utils/units";

export const useUnitSystem = (): UnitSystem => {
  const { user } = useAuth();
  return user?.unit_system === "imperial" ? "imperial" : "metric";
};
